import Vue from 'vue'
export default {
  getCustomerDetails (customerId) {
    return Vue.http.get(window.API_URL + 'doctors/customers/' + customerId + '/profile')
  }
}



// WEBPACK FOOTER //
// ./src/api/customer/profile.js